import { useMemo } from 'react';
import { useHouseContext } from '@/context/HouseContext';
import { useAuth } from '@/context/AuthContext';
import {
	type ClassifiedHouse,
	groupPropertiesByOwnership,
	type GroupedProperties,
} from '@/utils/properties/propertyGroupingUtils';

/** Groups the user's complete houses into owned, sharedWithUser, and archived. */
export const useGroupedProperties = (): GroupedProperties<ClassifiedHouse> => {
	const { completeHouses } = useHouseContext();
	const { user } = useAuth();
	return useMemo(() => groupPropertiesByOwnership(completeHouses, user?.id), [completeHouses, user?.id]);
};
